<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="650px"
    min-width="400px"
    scrollable
    @close="onDialogClose"
    :title="`${titleDialog} ${$t('sidebar.symbol.name')}`"
    width="50%"
  >
    <div id="app" style="max-height: 400px; min-height: 200px">
      <div>
        Dung lượng tối đa là 1MB. Chỉ hỗ trợ: PNG, JPEG, JPG.<br />
        Khuyên dùng ảnh kích thước 32x32 hoặc 64x64</div
      >
      <div v-if="errortext && imageArray.length" class="pt-0 error--text">
        {{ errortext }}
      </div>
      <div class="d-flex flex-wrap" style="width: 100%">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div @click="goUpload" v-bind="attrs" v-on="on">
              <div
                class="
                  select-image
                  d-flex
                  align-center
                  justify-center
                  mt-6
                  mr-6
                "
              >
                <input
                  :id="cbId"
                  accept="image/png,image/jpeg,image/jpg"
                  style="display: none"
                  type="file"
                  @change="onFileChange"
                  multiple
                />
                <v-icon size="60">mdi-plus</v-icon>
              </div>
            </div>
          </template>
          <span>Chọn hình ảnh, Icon từ máy tính</span>
        </v-tooltip>
        <div
          v-for="im in imageArray"
          :key="im.src"
          class="image-box d-flex align-center justify-center mr-6 mt-6"
        >
          <v-img
            class="cropper"
            :src="im.src"
            width="100px"
            max-height="100px"
          ></v-img>
          <v-btn
            icon
            color="pink"
            style="position: absolute; top: 0px; right: 0px"
            @click="removeImage(im)"
          >
            <v-icon size="25">mdi-close</v-icon>
          </v-btn>
          <div
            style="
              position: absolute;
              bottom: 1px;
              padding: 2px;
              background: white;
            "
            >{{
              im.name.length > 12 ? im.name.substring(0, 12) + '...' : im.name
            }}</div
          >
        </div>
      </div>
    </div>
    <template #extra-btn>
      <base-button
        v-if="imageArray && imageArray.length"
        class="mr-2"
        color="primary"
        text
        @click="imageArray = []"
      >
        Xoá
      </base-button>
      <base-button v-if="img" color="primary" @click="Upload" :loading="dialog.loading"
        >Tải lên</base-button
      >
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { mapGetters } from 'vuex'
import { API_SYMBOL } from '@api'

export default {
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    img: '',
    cbId: '',
    file: null,
    errortext: '',
    imageArray: [],
    formData: null,
  }),
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  watch: {
    dialog: {
      handler(value) {
        this.show = value
      },
      immediate: true,
    },
    show(value) {
      if (!value) this.$emit('close')
    },
  },
  mounted() {
    this.cbId = Math.random().toString(16).slice(2)
  },
  methods: {
    open(item, type) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.$set(this.dialog, 'data', Object.assign({ content: [] }, item))
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
      this.img = ''
      this.cbId = Math.random().toString(16).slice(2)
      this.file = null
      this.errortext = ''
      this.imageArray = []
    },
    getData() {
      this.$emit('reset')
    },
    onFileChange(e) {
      let files = Array.from(e.target.files)
      let imagerrors = 0
      let data = new FormData()
      const typeImage = ['image/jpeg', 'image/png', 'image/jpg']
      files.forEach((img) => {
        this.errortext = ''
        if (!img) return

        if (img.size > 1 * 1024 * 1024) {
          this.errortext = 'Chỉ chập nhận tập tin dưới 1MB'
          return
        }
        if (!typeImage.includes(img.type)) {
          this.errortext = 'Định dạng ảnh không hợp lệ'
          return
        }
        let image = new Image()
        let vm = this
        image.onload = function () {
          if (this.width) {
            var reader = new FileReader()
            reader.readAsDataURL(img)
            reader.onload = (e) => {
              let name = img.name.split('.')[0]
              vm.img = e.target.result
              vm.imageArray.push({ src: vm.img, name: name })
              data.append('file[]', img)
            }
          }
        }
        image.onerror = () => {
          imagerrors++
          this.errortext = imagerrors + ' tập tin không đúng dịnh dạng hình ảnh'
        }
        image.src = URL.createObjectURL(img)
      })
      this.formData = data
    },
    goUpload() {
      document.getElementById(this.cbId).click()
    },
    close() {
      this.show = false
      this.$emit('close')
      this.imageArray = []
    },
    async Upload() {
      this.dialog.loading = true
      let parent_id = this.$route.params.id
      let res = await API_SYMBOL.uploadIcon(this.formData, (e) => {}, parent_id)
      if (res && !res.error) {
        this.onDialogClose()
        this.getData()
      }
      this.dialog.loading = false
    },
    removeImage(src) {
      let indexImg = this.imageArray.indexOf(src)
      if (indexImg > -1) {
        this.imageArray.splice(indexImg, 1)
      }
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
.select-image {
  height: 120px;
  width: 120px;
  border: 1px solid #cacfd2;
  cursor: pointer;
}
.select-image:hover {
  border: 1px solid;
}
.image-box {
  height: 120px;
  width: 120px;
  border: 1px solid #cacfd2;
  position: relative;
}
</style>
